import { Button, Header, SpaceBetween } from "@amzn/awsui-components-console";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import AgentTraceButton from "@/components/buttons/AgentTraceButton";
import Chat from "@/components/chat/Chat";
import { useChat } from "@/contexts/ChatContext";
import { useUser } from "@/contexts/UserContext";

const ChatPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    title,
    conversationId,
    updateWithConversationId,
    previousChatLoading,
  } = useChat();
  const {
    user: { userId, isAdmin },
  } = useUser();
  const [searchParams] = useSearchParams();
  // Check based on the URL.
  useEffect(() => {
    const id = searchParams.get("thread");
    if (!id || id !== conversationId) {
      updateWithConversationId(id);
    }
  }, [searchParams, conversationId, updateWithConversationId]);

  const handleNewChat = () => {
    navigate("/");
  };

  return (
    <SpaceBetween size="xl">
      <Header
        variant="h1"
        actions={
          <SpaceBetween direction="horizontal" size="s">
            {conversationId && isAdmin && (
              <AgentTraceButton
                userId={userId}
                conversationId={conversationId}
              />
            )}
            <Button
              variant="primary"
              iconName="add-plus"
              onClick={handleNewChat}
            >
              Start New Chat
            </Button>
          </SpaceBetween>
        }
      >
        {previousChatLoading ? "Loading... " : title}
      </Header>
      <Chat />
    </SpaceBetween>
  );
};

export default ChatPage;
